import type { ResourceMap } from '@hostesa/i18n';

/**
 * i18n resources for the `team` namespace — the member roster page.
 *
 * The coordinator merges `resources` into the app i18n instance. Non-English
 * locales reuse the English copy as a temporary placeholder so the key-parity
 * check passes; translators replace the strings without changing the key shape.
 */

export const namespace = 'team' as const;

const en = {
  eyebrow: 'Settings',
  pageTitle: 'Team',
  pageDescription:
    'Everyone with access to this hotel — their role and account status. Invite teammates to share the front desk.',
  membersFigure: 'Members',
  inviteAction: 'Invite',
  table: {
    nameHeading: 'Name',
    roleHeading: 'Role',
    statusHeading: 'Status',
  },
  unnamed: 'Unnamed member',
  noEmail: 'No email',
  roles: {
    hotel_admin: 'Hotel admin',
    hotel_staff: 'Hotel staff',
    tenant_admin: 'Tenant admin',
  },
  status: {
    active: 'Active',
    suspended: 'Suspended',
  },
  states: {
    loading: 'Loading the team…',
    errorTitle: 'Could not load the team',
    errorDescription: 'Something went wrong while loading the member roster. Please try again.',
    retry: 'Retry',
    emptyTitle: 'No team members yet',
    emptyDescription: 'Invite a teammate to give them access to this hotel.',
  },
  manageDisabledHint: 'You do not have permission to invite members.',
  invite: {
    title: 'Invite a teammate',
    description:
      'Grant a new member access to this hotel. They sign in with the email and password you set.',
    emailLabel: 'Email',
    emailPlaceholder: 'name@hotel.com',
    emailRequired: 'Enter an email address.',
    emailInvalid: 'Enter a valid email address.',
    fullNameLabel: 'Full name',
    fullNamePlaceholder: 'Optional',
    passwordLabel: 'Temporary password',
    passwordPlaceholder: 'At least 8 characters',
    passwordRequired: 'Enter a password.',
    passwordTooShort: 'Use at least 8 characters.',
    roleLabel: 'Role',
    cancel: 'Cancel',
    submit: 'Send invite',
    submitting: 'Inviting…',
    error: 'Could not invite this member. Please try again.',
  },
};

export const resources: ResourceMap = {
  en: { [namespace]: en },
  bg: { [namespace]: en },
  de: { [namespace]: en },
  fr: { [namespace]: en },
};

export default { namespace, resources };
